import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ModalProgressBar } from "../../../../../_metronic/_partials/controls";
import * as actions from "../../../../../../src/app/actions/generalActions";
import { useSpecificationsUIContext } from "./SpecificationsUIContext";
import { useFilterObjectsUIContext } from "../pages/FilterObjectsUIContext";

const selectedSpecifications = (entities, ids) => {
  const _specifications = [];
  ids.forEach((id) => {
    const specification = entities.find((el) => el.id === id);
    if (specification) {
      _specifications.push(specification);
    }
  });
  return _specifications;
};

export function SpecificationsHardDeleteDialog({ api, showTitle, reduxName }) {
  const specsUIContext = useSpecificationsUIContext();
  const filterUIContext = useFilterObjectsUIContext();

  const specsUIProps = useMemo(() => {
    return {
      ids: specsUIContext.ids,
      show: specsUIContext.showHardDeleteSpecificationsDialog,
      onHide: specsUIContext.closeHardDeleteSpecificationsDialog,
      setIds: specsUIContext.setIds,
      queryParams: filterUIContext.queryParams,
      parentId: specsUIContext.parentId,
      parentName: specsUIContext.parentName,
    };
  }, [specsUIContext, filterUIContext]);

  const { specifications, isLoading, name } = useSelector(
    (state) => ({
      specifications: selectedSpecifications(state[reduxName].entities, specsUIProps.ids),
      isLoading: state[reduxName].actionsLoading,
      name: state[reduxName].name
    }),
    shallowEqual
  );

  const dispatch = useDispatch();
  // looking for loading/dispatch
  useEffect(() => { }, [isLoading, dispatch]);

  // if there weren't selected specs we should close modal
  useEffect(() => {
    if (!specsUIProps.ids || specsUIProps.ids.length === 0) {
      specsUIProps.onHide();
    }

  }, [specsUIProps.ids]);

  const deleteObjects = () => {
    dispatch(actions.deleteObjects(api, name, specsUIProps.ids, false)).then(() => {
      dispatch(actions.fetchObjects(api, name, specsUIProps.queryParams)).then(() => {
        specsUIProps.setIds([]);
        specsUIProps.onHide();
      });
    });
  };

  return (
    <Modal
      show={specsUIProps.show}
      onHide={specsUIProps.onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {isLoading && <ModalProgressBar />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          حذف قطعی چند تایی
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>آیا از حذف قطعی موارد انتخاب شده اطمینان دارید ؟</span>
        )}
        {isLoading && <span>در حال حذف قطعی ...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={specsUIProps.onHide}
            className="btn btn-light btn-elevate"
          >
            انصراف
          </button>
          <> </>
          <button
            type="button"
            onClick={deleteObjects}
            className="btn btn-primary btn-elevate"
          >
            حذف قطعی همه
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
